import React from 'react'
import Helmet from 'react-helmet'
var ScrollMagic
if (typeof window === 'object') {
    ScrollMagic = require('scrollmagic')
}

import CustomHelmet from '../components/CustomHelmet'
import ApplyInterest from '../components/Apply-Interest'
import Afterhero from '../components/Program/Afterhero'
import Destinations from '../components/Program/Destinations'
import Download from '../components/Program/Download'
import Experience from '../components/Program/Experience'
import FAQ from '../components/Program/FAQ'
import Hero from '../components/Program/Hero'
import Navigation from '../components/Program/Navigation'


// if(typeof window == 'object') {
// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
// }

class ProgramOverview extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            activeNav: '',
            controller: null
        }
    }

    componentDidMount() {
        // console.log('TAKE 2 ==>', this.pageNav);
        let experience = document.querySelector('#experience'),
              destinations = document.querySelector('#destinations'),
              faq = document.querySelector('#faq'),
              offset = 420;

        this.controller = new ScrollMagic.Controller()
        this.setState({
            controller: this.controller
        })
        setTimeout( () => this.navSceneInit(), 450)

        window.addEventListener('scroll', () => {
            let experienceTrigger = (experience.offsetTop - offset),
            destinationsTrigger = (destinations.offsetTop - offset),
            faqTrigger = (faq.offsetTop - offset)

            let doc = document.documentElement,
            top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)

            if (top > faqTrigger) {
                this.state.activeNav != 'faq' ? this.setState({activeNav: 'faq'}) : null
            } else if (top > destinationsTrigger) {
                this.state.activeNav != 'destinations' ? this.setState({activeNav: 'destinations'}) : null
            } else if (top > experienceTrigger) {
                this.state.activeNav != 'experience' ? this.setState({activeNav: 'experience'}) : null
            } else {
                this.state.activeNav != '' ? this.setState({activeNav: ''}) : null
            }
        })
    }
	componentWillUnmount() {
        this.state.controller.destroy(true)
        this.controller.destroy(true)
	}
    navSceneInit() {
        var triggerHook = window.innerWidth > 768 ? .3 - 207 / window.innerHeight : 45 / window.innerHeight

        this.navScene = new ScrollMagic.Scene({
            triggerElement: this.pageNav,
            triggerHook
        })
        .setPin(this.pageNav.children[0])
        .addTo(this.controller)
        // .addIndicators()
    }
    render() {
        const { data: { page } } = this.props;
        const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``;
        // console.log('THE PAGE DATA ===>', page);
        return (
            <div className="program">
                <CustomHelmet data={ page.seoData } />
                <Hero
                    title={page.title}
                    image={page.heroImage}
                />
                <Navigation
                    activeNav={this.state.activeNav}
                    callbackRef={ el => this.pageNav = el }
                />
                <Afterhero
                    text={page.heroSplashText.heroSplashText}
                />
                <Experience
                    title={page.experienceTitle}
                    steps={page.experienceSteps}
                />
                <Download
                    file={ page.pdfDownload }
                />
                <Destinations
                    title={page.destinationsTitle}
                    text={page.destinationsText}
                    link={page.destinationsLink}
                    cards={page.destinationItems}
                />
                <FAQ
                    title={page.faqTitle}
                    items={page.faqItems}
                    link={page.faqLink}
                />
                <ApplyInterest
                    title={page.applyTitle}
                />
            </div>
        );
    }
}

export default ProgramOverview

export const query = graphql`
  query ProgramOverviewPageQuery {
    page: contentfulProgramPage {
      title
      heroImage {
          sizes(quality:100, maxWidth:1200) {
              ...GatsbyContentfulSizes_withWebp
          }
        title
        file {
          url
          fileName
          contentType
        }
      }
      heroSplashText {
        heroSplashText
      }
      experienceTitle
      experienceSteps {
        timeframe
        title
        details {
          details
        }
      }

      destinationsTitle
      destinationsText
      destinationsLink {
        link
        text
      }
      destinationItems {
  		  featuredImage {
              sizes(quality:100, maxWidth:1800) {
                ...GatsbyContentfulSizes_withWebp
              }
              file {
                url
              }
              title
            }
            link {
              link
              text
            }
  		}
      pdfDownload {
        id
        file {
          url
          fileName
          contentType
        }
      }
      faqTitle
      faqItems {
        question
        answer {
          answer
        }
      }
      faqLink {
        text
        link
      }
      applyTitle
      seoData {
        id
        pageTitle
        pageDescription {
          id
          pageDescription
        }
        keywords
        openGraphTitle
        openGraphDescription {
          id
          openGraphDescription
        }
        openGraphImage {
          id
          file {
            url
            fileName
            contentType
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/program-overview.js